<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<ValidationProvider name="customer_id" v-slot="{ errors, valid }">
					<v-autocomplete v-model="item.customer_id" :items="customers" item-value="id" item-text="display_name" :label="$t('label.customer')" filled :errors="errors" :valid="valid"></v-autocomplete>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md12>
				<ValidationProvider name="membership_id" v-slot="{ errors, valid }">
					<v-autocomplete v-model="item.membership_id" :items="memberships" item-value="id" item-text="name" :label="$t('label.memberships')" filled :errors="errors" :valid="valid"></v-autocomplete>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md6>
				<ValidationProvider name="membership_id" v-slot="{ errors, valid }">
					<v-autocomplete v-model="item.payment_status" :items="payment_statuses" :label="$t('label.payment_status')" :errors="errors" :valid="valid" filled></v-autocomplete>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md6>
				<ValidationProvider name="payment_method_code" v-slot="{ errors, valid }">
					<v-autocomplete v-model="item.payment_method_code" :items="payment_methods" :label="$t('label.payment_method_code')" :errors="errors" :valid="valid" filled></v-autocomplete>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md6>
				<ValidationProvider name="parsed_starts_at" v-slot="{ errors, valid }">
					<v-text-field type="date" v-model="item.parsed_starts_at" :label="$t('Start Date')" :errors="errors" :valid="valid" filled></v-text-field>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md6>
				<ValidationProvider name="parsed_ends_at" v-slot="{ errors, valid }">
					<v-text-field type="date" v-model="item.parsed_ends_at" :label="$t('End Date')" :errors="errors" :valid="valid" filled></v-text-field>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md4>
				<v-switch v-model="item.paid" inset :label="$t('Paid')"></v-switch>
			</v-flex>
			<v-flex xs12 md12>
				<v-textarea v-model="item.description" :label="$t('Description')" filled></v-textarea>
			</v-flex>
		</v-layout>
		<v-subheader><strong>{{ $t("label.state") }}</strong>
		</v-subheader>
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn-toggle v-model="item.state" borderless active-class="white--text">
					<v-btn value="pending" color="light-blue darken-1" dark>
						<v-icon left v-if="item.state == 'pending'" dark color="white">mdi-check</v-icon>
						<span>Pending</span>
					</v-btn>

					<v-btn value="canceled" color="red darken-4" dark>
						<v-icon left v-if="item.state == 'canceled'" dark color="white">mdi-check</v-icon>
						<span>canceled</span>
					</v-btn>

					<v-btn value="approved" color="teal darken-3" dark>
						<v-icon left v-if="item.state == 'approved'" dark color="white">mdi-check</v-icon>
						<span>approved</span>
					</v-btn>

					<v-btn value="suspended" color="green darken-3" dark>
						<v-icon left v-if="item.state == 'suspended'" dark color="white">mdi-check</v-icon>
						<span>suspended</span>
					</v-btn>
					<v-btn value="expired" color="light-green" dark>
						<v-icon left v-if="item.state == 'expired'" dark color="white">mdi-check</v-icon>
						<span>expired</span>
					</v-btn>
				</v-btn-toggle>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
	export default {
		props: ["value", "customers", "memberships"],
		data() {
			return {
				payment_statuses: [
					{
						text: this.$t("Pending"),
						value: "pending",
					},
					{
						text: this.$t("Paid"),
						value: "paid",
					},
					{
						text: this.$t("Canceled"),
						value: "canceled",
					},
					{
						text: this.$t("Refunded"),
						value: "refunded",
					},
					{
						text: this.$t("Failed"),
						value: "failed",
					},
					{
						text: this.$t("Expired"),
						value: "expired",
					},
				],
				payment_methods: [
					{
						text: this.$t("label.COD"),
						value: "COD",
					},
					{
						text: this.$t("label.PAYWAY"),
						value: "PAYWAY",
					},
					{
						text: this.$t("label.ABAPAY"),
						value: "ABAPAY",
					},
					{
						text: this.$t("label.CARD"),
						value: "CARD",
					},
				],
			};
		},
		computed: {
			item: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit("input", value);
				},
			},
		},
	};
</script>